import { Injectable } from '@angular/core';
import { AppCommon } from '../app-common';

export interface UserAvatarLookup {
  userId?: number | string | null;
  userName?: string | null;
  userEmail?: string | null;
  imageUrl?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class UserAvatarService {
  private loggedInUser = AppCommon.getloggedInObject()?.user;
  private googleUser = AppCommon.getGoogleUserObject();

  getPhotoFor(user: UserAvatarLookup): string | null {
    if(this.isLoggedInUser(user)){
      return this.googleUser?.photoUrl || user.imageUrl || null;
    }
    return user.imageUrl || null;
  }

  isLoggedInUser(user: UserAvatarLookup): boolean {
    const userEmail = this.normalize(user.userEmail);
    const googleEmail = this.normalize(this.googleUser?.email);
    if(userEmail && googleEmail){
      return userEmail == googleEmail;
    }

    if(user.userId !== null && user.userId !== undefined && this.loggedInUser?.id !== undefined){
      return String(user.userId) == String(this.loggedInUser.id);
    }

    const userName = this.normalize(user.userName);
    const googleName = this.normalize(this.googleUser?.name);
    return !!userName && !!googleName && userName == googleName;
  }

  private normalize(value: string | null | undefined): string {
    return (value || '').trim().toLowerCase();
  }
}
